import { Regulations } from '../../api/fishrules/getSpeciesRegulationsAtLocation';

interface RestrictionsAndRequirements {
  id: number;
  label: string;
  name: string;
  description: string;
  type: string;
}

const getRestrictionsAndRequirements = (regulation: Regulations): RestrictionsAndRequirements[] => [
  ...regulation.prohibitions,
  ...regulation.restrictions,
  ...regulation.requirements,
];

const hasRestrictions = (regulation: Regulations): boolean =>
  getRestrictionsAndRequirements(regulation).length > 0;

export { getRestrictionsAndRequirements, hasRestrictions };
